export default {
  namespaced: true,
  state: {
    data: null
  },
  getters: {
    data (state) {
      return state.data
    },
    loggedIn (state) {
      return state.data !== null
    }
  },
  mutations: {
    data (state, data) {
      state.data = data
    }
  },
  actions: {
    saveData ({ commit }, data) {
      commit('data', data)
    }
  }
}
